"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var SummaryTable = function SummaryTable(props) {
  var data = props.data;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].tableWrapper
  }, /*#__PURE__*/_react["default"].createElement("table", {
    className: 'table table-condensed ' + _style["default"].table
  }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", null, "Summary"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-center"
  }, "Value"), data.columns.filter(function (column) {
    return !column.isOthers;
  }).map(function (column) {
    return /*#__PURE__*/_react["default"].createElement("th", {
      key: column.code,
      className: "text-center"
    }, column.label);
  }))), /*#__PURE__*/_react["default"].createElement("tbody", null, data.rows.map(function (row) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: row.label
    }, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("strong", null, row.label.toUpperCase())), /*#__PURE__*/_react["default"].createElement("td", {
      className: "text-center"
    }, row.total), row.values.map(function (value, index) {
      return /*#__PURE__*/_react["default"].createElement("td", {
        key: index,
        className: "text-center"
      }, value);
    }));
  }))));
};
SummaryTable.propTypes = {
  data: _propTypes["default"].object
};
var _default = SummaryTable;
exports["default"] = _default;